import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export default function BioCheck(props) {
  const [random, setRandom] = useState(0);
  const [update, setUpdate] = useState(false);
  const [select, setSelect] = useState(false);

  const styleData = [
    {
      color: "#A67C0A",
      backgroundColor: "#FFFAED",
    },
    {
      color: "#7B0D06",
      backgroundColor: "#FFF1F0",
    },
    {
      color: "#004307",
      backgroundColor: "#ECFFEE",
    },
    {
      color: "#44023D",
      backgroundColor: "#FFF0FE",
    },
  ];
  console.log(props.val.uuid);
  useEffect(() => {
    function getRandomInt(max) {
      return Math.floor(Math.random() * max);
    }
    setRandom(getRandomInt(4));
  }, []);
  const selected_test = useSelector(
    (state) => state.selected_test.selected_test
  );
  const test = useSelector((state) => state);

  return (
    <div
      className="CardSelectTest"
      style={
        selected_test.includes(props.val) ? { border: "2px solid #FFAD05" } : {}
      }
    >
      <div
        className="headerContainer"
        style={
          selected_test.includes(props.val)
            ? { background: "#FFFBF2" }
            : { backgroundColor: styleData[random].backgroundColor }
        }
      >
        <div
          className="headtext"
          style={
            selected_test.includes(props.val)
              ? { color: "#66490D" }
              : { color: styleData[random].color }
          }
        >
          {props && props.heading && props.heading !== undefined
            ? props.heading
            : ""}
        </div>
        <div
          className="sub-head-text"
          style={selected_test.includes(props.val) ? { color: "#66490D" } : {}}
        >
          {props.subHeading}
        </div>
      </div>
      <div className="CardTxt">{props.des}</div>

      {selected_test.includes(props.val) ? (
        <div
          className="Card_btn"
          style={selected_test.includes(props.val) ? { color: "#66490D" } : {}}
          onClick={() => props.handleItemDelete(props.val)}
        >
          Remove Test
        </div>
      ) : !props &&
        !props.addedItems &&
        !props.addedItems.includes(props.val) ? (
        <div
          className="Card_btn"
          style={{ color: "#163E8C" }}
          onClick={() => props.handleItems(props.id, props.val)}
        >
          BUY TEST
        </div>
      ) : (
        <div
          className="Card_btn"
          style={{ color: "#163E8C" }}
          onClick={() => props.handleItems(props.val, props.val)}
        >
          BUY TEST
        </div>
      )}
    </div>
  );
}
